import { render, staticRenderFns } from "./VTableHeaders.vue?vue&type=template&id=6188198a&scoped=true&"
import script from "./VTableHeaders.vue?vue&type=script&lang=js&"
export * from "./VTableHeaders.vue?vue&type=script&lang=js&"
import style0 from "./VTableHeaders.vue?vue&type=style&index=0&id=6188198a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6188198a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VIcon,VRow,VSimpleCheckbox})
